import { render } from "./SupplierMultiSelect.vue?vue&type=template&id=44661f00&scoped=true&ts=true"
import script from "./SupplierMultiSelect.vue?vue&type=script&lang=ts"
export * from "./SupplierMultiSelect.vue?vue&type=script&lang=ts"

import "./SupplierMultiSelect.vue?vue&type=style&index=0&id=44661f00&lang=scss&scoped=true"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44661f00"]])

export default __exports__